var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBradyindustriesProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41586,
    stopColor: "#225994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#234b8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23248d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.79913,48.17163c.36646.21155.81793.21155,1.18439,0l16.11835-9.30554c.78961-.45587.78961-1.59552.00006-2.05139l-5.60986-3.23883-18.48676,10.67346,6.79382,3.9223Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.68121,38.86615l5.13184,2.96283,18.48712-10.67334-6.31641-3.64673c-.36646-.21161-.81793-.21161-1.18439,0l-16.11816,9.30585c-.78961.45587-.78961,1.59552,0,2.05139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.38428,63.14972l16.18445,9.34412c.7674.44305,1.72656-.11072,1.72656-.99677v-18.68817c0-.41125-.21942-.7912-.5755-.99683l-6.87177-3.96753v9.87964l-4.19208-2.17682v-10.12317l-5.12067-2.95642c-.76733-.44305-1.7265.11072-1.7265.99683v18.68835c0,.41119.21936.7912.5755.99677Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.49011,66.56189c1.95312.57007,3.9585-.04315,5.27362-1.53003,1.24396-1.39154,1.58942-3.71619.74243-5.3938-.39764-.85474-1.09766-1.64227-1.90216-2.16144-1.52997-1.01929-3.95001-.95856-5.43622.10449-1.78143,1.22699-2.53235,3.33557-2.07593,5.37616.34613,1.59924,1.82452,3.15466,3.39825,3.60461Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.27863,62.57788l.00781,10.0719,22.35419-.01111.85547-.20697c.92462-.37225,1.57373-1.34784,1.63312-2.31683v-4.96216l-.12079-.70856c-.29388-.9762-1.26294-1.71997-2.26526-1.82318l-6.22314-.01697c-.19849,1.39941-.78687,2.63617-1.7807,3.70709-1.83301,1.96295-4.79694,2.59375-7.26074,1.58221-2.15228-.85541-3.82916-3.04169-4.0708-5.31543h-3.12915Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.33148,61.02246l3.07629-.01697c.23315-1.75531,1.02783-3.32837,2.53235-4.50378,1.8147-1.4353,4.61609-1.78857,6.74158-.78619,2.10071.90765,3.6568,3.09387,3.86444,5.30695h5.28931c.60535-.01703,1.2453.02545,1.76379-.22467.83844-.38916,1.51367-1.21783,1.59198-2.14313l-.01758-5.16132-.14758-.78625c-.29388-.89917-1.2453-1.86493-2.22351-1.85382l-22.48151.00781.01044,10.16138Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBradyindustriesProductsScraper);
export default __webpack_public_path__ + "static/media/bradyindustries-products-scraper.7b8c30e97e061bdcb015e410f3a82e9a.svg";
export { ForwardRef as ReactComponent };